import CalendarEventComponent from './calendar_meeting';
import { CalendarIcon } from '@mui/x-date-pickers';
import MeetingEventComponent from './meeting_card_component';
import moment from 'moment';
import { RootState } from '../../redux/store';
import TabsHeader from './tabs_header';
import { TransformedCalendarEventObject } from '../../params/redux/calendar';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { brand, gray } from '../../theme/themePrimitives';
import { Calendar, momentLocalizer, Views } from 'react-big-calendar';

// import 'react-big-calendar/lib/sass/styles';
import 'react-big-calendar/lib/css/react-big-calendar.css';
// import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';

const localizer = momentLocalizer(moment);

const OverviewComponent = () => {
    const { transformedEvents, events, calendarReminders } = useSelector((state: RootState) => state.calendar);
    const [searchQuery, setSearchQuery] = useState('');
    const [sort, setSort] = useState<boolean>(false);

    const upcomingEvents = [...(events || [])]
        .filter((event) => moment(event?.start_date).isAfter(moment()) && event?.meeting_link !== null)
        .sort((a, b) => moment(a?.start_date).diff(moment(b?.start_date)))
        .slice(0, 4);

    const formattedEvents = [...transformedEvents, ...calendarReminders].map((event) => ({
        ...event,
        start: new Date(event.start),
        end: new Date(event.end)
    })) || [];

    const eventPropGetter = (event: TransformedCalendarEventObject) => {
        return {
            style: {
                'backgroundColor': event.color,
                '& :hover': {
                    backgroundColor: brand[500]
                }
            }
        };
    };

    return (
        <Box borderTop={`1px solid ${gray[100]}`} minHeight="80vh">
            <TabsHeader isOverView={true} searchQuery={searchQuery} setSearchQuery={setSearchQuery} notToShow={false} sort={sort} setSort={(value: boolean) => setSort(value)} />
            <Box height="45vh">
                <Calendar
                    localizer={localizer}
                    events={formattedEvents}
                    startAccessor="start"
                    endAccessor="end"
                    titleAccessor="title"
                    defaultView={Views.MONTH}
                    dayLayoutAlgorithm="no-overlap"
                    showMultiDayTimes
                    step={60}
                    components={{
                        event: ({ event }) => {
                            return <CalendarEventComponent event={event} />;
                        }
                    }}
                    eventPropGetter={eventPropGetter}
                    onSelectEvent={() => null}
                />
            </Box>
            <Box display="flex" alignItems="center" gap="10px" mt={2} color={gray[500]}><CalendarIcon /><Typography variant="h5" color="textSecondary">Upcoming Events</Typography></Box>
            <Box display="flex" justifyContent="start" flexWrap="wrap" gap="10px" mt={2}>
                {
                    upcomingEvents.map((event, index) => (
                        <Box
                            key={index}
                            minWidth="24.5%"
                            maxWidth="24.5%"
                        >
                            <MeetingEventComponent event={event} />
                        </Box>
                    ))
                }
            </Box>
        </Box>
    );
};

export default OverviewComponent;
